import {actions, selectors} from './Redux/index';
import {isEmpty, find} from 'lodash';
import {executeWebtrekk} from './Utility/Webtrekk/WebtrekkMapp';

const api = '/api';
const download = '/downloads';

/**
 * This maps the application's routes to the according api endpoints
 * and Saga Actions for START and SUCCESS
 */
export const mappings = [
    {
        route: '/',
        reloadTime: 30 * 1000,
        endpoint: '/homepage',
        getEndpoint: () => {
            return '/homepage'
        },
        optionsSelector: (state) => {
            const options = selectors.UI.HomeOptions.getHomeOptions(state);
            const isImmutable = options && typeof options.toJS === 'function';
            return {
                ...(isImmutable ? options.toJS() : (options || {})),
                client: selectors.UI.Breakpoint.currentBreakpoint(state)
            };
        },
        action: {
            start: actions.Data.Dashboard.sagaLoadDataStart,
            success: actions.Data.Dashboard.sagaLoadDataSuccess
        }
    },
    {
        route: '/settlement',
        endpoint: '/settlement',
        getEndpoint: () => {
            return '/settlement'
        },
        optionsSelector: selectors.UI.SettlementOptions.getSettlementOptions,
        action: {
            start: actions.Data.Settlement.sagaLoadDataStart,
            success: actions.Data.Settlement.sagaLoadDataSuccess
        }
    },
    {
        route: '/spot',
        reloadTime: 30 * 1000,
        endpoint: '/spot',
        getEndpoint: () => {
            return '/spot'
        },
        optionsSelector: selectors.UI.SpotOptions.getSpotOptions,
        action: {
            start: actions.Data.Spot.sagaLoadDataStart,
            success: actions.Data.Spot.sagaLoadDataSuccess
        }
    },
    {
        route: '/forward',
        reloadTime: 30 * 1000,
        endpoint: '/forward',
        getEndpoint: () => {
            return '/forward'
        },
        optionsSelector: selectors.UI.ForwardOptions.getForwardOptions,
        action: {
            start: actions.Data.Forward.sagaLoadDataStart,
            success: actions.Data.Forward.sagaLoadDataSuccess
        }
    },
    {
  route: '/currency-details',
 
  reloadTime: 30 * 1000,
 
  endpoint: '/detail',
 
  optionsSelector: (state) => {
    const searchStr = window.location.hash.includes('?') 
      ? window.location.hash.substring(window.location.hash.indexOf('?'))
      : window.location.search;
    const urlParams = new URLSearchParams(searchStr);
    return { currencyPair: urlParams.get('currencyPair') };
  },

  getEndpoint: (queryParams) => {
 
    const searchStr = window.location.hash.includes('?') 
      ? window.location.hash.substring(window.location.hash.indexOf('?'))
      : window.location.search;
    const urlParams = new URLSearchParams(searchStr);
 
    const pair =
      queryParams?.currencyPair ||
      queryParams?.get?.('currencyPair') ||
      urlParams.get('currencyPair');
 
    if (!pair) {
      return '';
    }
 
   return `/detail/${pair}`;
  },
 
  action: {
    start: actions.Data.CurrencyPair.sagaLoadDataStart,
    success: actions.Data.CurrencyPair.sagaLoadDataSuccess
  }
}
];

export default api;
export const downloadPath = download;

export const onRouteEnter = enteringRoute => (nextState, replace) => {
    executeWebtrekk();
    const route = find(mappings, m => m.route === enteringRoute);
    const query = nextState.location.query || {};
    if (!isEmpty(route.query) && Object.keys(query).length === 0) {
        const location = Object.assign({}, nextState.location);
        location.query = route.query;
        replace(location);
    } else {
        route.query = query;
    }
};

export const onRouteChange = changingRoute => (prevState, nextState) => {
   const route = find(mappings, m => m.route === changingRoute);
 
   const prevCurrencyPair =
      prevState.location.query?.currencyPair;
 
   const nextCurrencyPair =
      nextState.location.query?.currencyPair;
 
   if (prevCurrencyPair !== nextCurrencyPair) {
      route.query = {
         ...nextState.location.query,
         _reload: Date.now()
      };
   } else {
      route.query = nextState.location.query;
   }
};